import { render, staticRenderFns } from "./ApplicationTypeStep.vue?vue&type=template&id=6c90b644&scoped=true&"
import script from "./ApplicationTypeStep.vue?vue&type=script&lang=js&"
export * from "./ApplicationTypeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90b644",
  null
  
)

export default component.exports